<template><TableWlPrices /></template>
<script>
import TableWlPrices from '../config/TableWlPrices.vue'
export default { name: 'ReportPrices', components: { TableWlPrices } }
</script>
